import { CustomProperty, PropertyTableColumnBody, renderDefinedByColumnBody, renderTypeColumnBody } from '../..';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import InfoIcon from '../../../../components/TooltipIcon';

export default function CollectionTable({ property }: { property: CustomProperty }) {
  const { relatedObjectProperties, groupId } = property;

  if (!relatedObjectProperties?.length || groupId === 'associations') {
    throw new Error(
      'Invalid property provided for CollectionTable. Property must have relatedObjectProperties and not be an association.',
    );
  }

  return (
    <div className='w-full h-full py-1 pl-10 pr-6'>
      <div className='flex gap-2 items-center mb-4'>
        <p className='text-slate-500 text-md font-semibold'>Properties for {property.label} collection</p>

        <InfoIcon
          id={`collection-info-tooltip-${property.groupId}`}
          tooltip={`Like associations, you can display these fields by looping \nover each item in the ${property.label} collection. \nFor more information, see instructions for displaying associations.`}
        />
      </div>
      <DataTable
        value={relatedObjectProperties}
        stripedRows
        pt={{
          root: { style: { padding: 0 } },
          bodyRow: { style: { height: '82px' } },
        }}
      >
        <Column field='label' header='Name' className='font-medium' />
        <Column
          field='name'
          header='Property'
          body={(property) => <PropertyTableColumnBody property={property} composeProperty={false} />}
        />
        <Column field='type' header='Type' body={renderTypeColumnBody} />
        <Column field='isCustom' header='' style={{ width: '70px' }} body={renderDefinedByColumnBody} />
      </DataTable>
    </div>
  );
}
